import { DataTable } from '../../../design-system/data-table/data-table';
import { BeneficiaryView } from '../../../types/entity-types';
import { beneficiaryTableColumnsDefinition } from './beneficiary-table-column-definition';

type SortVariant = 'name' | 'lastPaid';

type BeneficiaryTableConfig = {
  sortVariant?: SortVariant;
  showPagination?: boolean;
  pageSize?: number;
  showSearch?: boolean;
};

type BeneficiaryTableProps = {
  beneficiaries: BeneficiaryView[];
  config?: BeneficiaryTableConfig;
  className?: string;
  onInitiateBeneficiaryPayment: (beneficiaryId: string) => void;
};

export const BeneficiaryTable = ({
  beneficiaries,
  config = {
    sortVariant: 'lastPaid',
    showPagination: false,
    pageSize: 5,
    showSearch: false,
  },
  className,
  onInitiateBeneficiaryPayment,
}: BeneficiaryTableProps) => {
  return (
    <DataTable
      data={beneficiaries}
      columns={beneficiaryTableColumnsDefinition}
      meta={{ onInitiateBeneficiaryPayment }}
      filters={{
        show: true,
        globalSearchConfig: { withGlobalSearch: config.showSearch ?? false, placeholder: 'Search recipients' },
        enableDateRangeFilter: false,
      }}
      initialSorting={config.sortVariant === 'name' ? [{ id: 'name', desc: false }] : [{ id: 'lastPaid', desc: true }]}
      showPagination={config.showPagination}
      pageSize={config.pageSize}
      className={className}
    />
  );
};
